/**
 * Pre-order flow: set REACT_APP_PREORDER_GOOGLE_FORM_URL to your Google Form link
 * (Send → link, or address bar). When unset, the pre-order page uses the on-page form
 * and opens a mail draft with the submitted fields.
 *
 * Embeds require the fill-out URL; we normalize common mistakes (/edit, trailing /, missing viewform, hhttps).
 */
function normalizeGoogleFormEmbedUrl(raw) {
  if (raw == null || typeof raw !== 'string') return '';
  let s = raw.trim().replace(/^h+(ttps?:\/\/)/i, 'https://');
  if (!s) return '';
  if (!/^https?:\/\//i.test(s)) s = `https://${s}`;

  let url;
  try {
    url = new URL(s);
  } catch {
    return '';
  }

  const host = url.hostname.toLowerCase();
  if (host === 'forms.gle' || host.endsWith('.forms.gle')) {
    return url.toString();
  }

  if (!host.endsWith('docs.google.com') || !url.pathname.includes('/forms/')) {
    return url.toString();
  }

  let path = url.pathname.replace(/\/+$/, '');
  if (/\/edit$/i.test(path)) path = path.replace(/\/edit$/i, '');
  if (!/\/viewform$/i.test(path)) path += '/viewform';
  url.pathname = path;
  url.hash = '';
  return url.toString();
}

// Use direct process.env.REACT_APP_* references so CRA/webpack DefinePlugin inlines them.
const rawPreorderFormUrl = process.env.REACT_APP_PREORDER_GOOGLE_FORM_URL || '';

export const PREORDER_GOOGLE_FORM_URL = normalizeGoogleFormEmbedUrl(rawPreorderFormUrl);

export const PREORDER_CONTACT_EMAIL =
  process.env.REACT_APP_PREORDER_CONTACT_EMAIL || 'hello@shokiq.com';

const publicBase = process.env.PUBLIC_URL || '';

/** About page — team portraits in `public/img/profile/` (override with full URL if needed). */
export const TEAM_JACK_PROFILE_IMAGE =
  (typeof process !== 'undefined' && process.env.REACT_APP_TEAM_JACK_PROFILE_IMAGE) ||
  `${publicBase}/img/profile/jack_harle_profile.jpg`;
export const TEAM_JEROME_PROFILE_IMAGE =
  (typeof process !== 'undefined' && process.env.REACT_APP_TEAM_JEROME_PROFILE_IMAGE) ||
  `${publicBase}/img/profile/jerome_lacote_profile.jpg`;
